module.exports = __webpack_public_path__ + "roboto-light-webfont.2beaab5524b6221c9f10.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-light-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto-light-webfont.svg
// module chunks = styles